import { mobileDeviceTypes } from "@helpers/constants";
import { isBrowser } from "@services/identity.service";

export const isValidResponseEntity = (response) => {
    return (response?.status && response?.entity) || false;
};

export const isValidGenAiResponse = (response) => {
    return (response?.success && response?.data) || false;
};
/**
 * Append query parameters from object to the url path and return the new path
 */
export const appendQueryParametersToPath = ({ queryParamObject, path }) => {
    if (typeof queryParamObject === 'object' && Object.keys(queryParamObject).length > 0 && path) {
        let queryString = '?';
        for (let key in queryParamObject) {
            if (queryString !== '?') {
                queryString += '&'
            }
            queryString += `${key}=${queryParamObject[key]}`;
        }

        return `${path}${queryString}`;
    }
    return path ? path : '';
}

/**
 * Get OS of device
 */
export const getMobileOS = () => {
    if (isBrowser()) {
        const userAgent = navigator.userAgent.toString().toLowerCase();
        if (userAgent.includes(mobileDeviceTypes.android)) {
            return mobileDeviceTypes.android;
        }
        if (userAgent.includes("iphone") || userAgent.includes("ipad") || userAgent.includes(mobileDeviceTypes.ios)) {
            return mobileDeviceTypes.ios;
        }
    }
    return mobileDeviceTypes.unknown;
};

// Used to replace anchor tags with spans of the given element and its children
export function replaceAnchorsWithSpans(element, onClickCallback) {
    function traverseAndReplace(node) {
        if (node instanceof HTMLAnchorElement) {
            const span = document.createElement('span');
            span.innerHTML = node.innerHTML;
            // Copy attributes (including styles and classNames)
            for (const { name, value } of node.attributes) {
                span.setAttribute(name, value);
            }
            span.onclick = function () {
                onClickCallback(node.getAttribute('href'));
            };
            node.parentNode.replaceChild(span, node);
        }

        if (node.childNodes && node.childNodes.length > 0) {
            for (let i = 0; i < node.childNodes.length; i++) {
                traverseAndReplace(node.childNodes[i]);
            }
        }
    }

    traverseAndReplace(element);
}

// removes query string and returns url with a forward slash
export function removeQueryStringFromUrl(url) {
    try {
        const parsedURL = new URL(url);
        parsedURL.search = ''; // Setting the search property to an empty string removes the query string
        let returnStr = parsedURL.toString();
        if (returnStr[returnStr.length - 1] != '/') {
            returnStr = `${returnStr}/`;
        }
        return returnStr;
    } catch (error) {
        return '';
    }
}
